import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5344b632&scoped=true&"
import script from "./index.js?vue&type=script&lang=js&"
export * from "./index.js?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=5344b632&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5344b632",
  null
  
)

export default component.exports